import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'
import {
  CHART_DEFAULT_NAME_KEY,
  CHART_POINTER_EVENTS_PROPS,
  CHART_RESPONSIVE_CONTAINER_PROPS,
} from '../Chart.constants'
import { renderChartLegendText } from '../Chart.utils'

import {
  AREA_CHART_DEFAULT_PROPS,
  AREA_CHART_GRID_DEFAULT_PROPS,
  AREA_CHART_LEGEND_DEFAULT_PROPS,
  AREA_CHART_TOOLTIP_DEFAULT_PROPS,
  AREA_CHART_X_AXIS_DEFAULT_PROPS,
  AREA_CHART_Y_AXIS_DEFAULT_PROPS,
  AREA_DEFAULT_PROPS,
} from './ChartArea.constants'

function ChartArea({
  areaProps = AREA_DEFAULT_PROPS,
  chartProps = AREA_CHART_DEFAULT_PROPS,
  data = EMPTY_LIST,
  gridProps = AREA_CHART_GRID_DEFAULT_PROPS,
  legendProps = AREA_CHART_LEGEND_DEFAULT_PROPS,
  nameKey = CHART_DEFAULT_NAME_KEY,
  series = EMPTY_LIST,
  tooltipProps = EMPTY_OBJECT,
  xAxisProps = AREA_CHART_X_AXIS_DEFAULT_PROPS,
  yAxisProps = AREA_CHART_Y_AXIS_DEFAULT_PROPS,
}) {
  return (
    <ResponsiveContainer {...CHART_RESPONSIVE_CONTAINER_PROPS}>
      <AreaChart {...CHART_POINTER_EVENTS_PROPS} {...chartProps} data={data}>
        <CartesianGrid {...gridProps} />
        <XAxis {...xAxisProps} dataKey={nameKey} />
        <YAxis {...yAxisProps} />
        <Tooltip {...AREA_CHART_TOOLTIP_DEFAULT_PROPS} {...tooltipProps} />
        <Legend
          {...legendProps}
          formatter={legendProps.formatter ?? renderChartLegendText}
        />
        {series.map(item => (
          <Area
            {...areaProps}
            activeDot={{ ...areaProps.activeDot, fill: item.color }}
            dataKey={item.dataKey}
            dot={{ ...areaProps.dot, fill: item.color }}
            fill={item.color}
            key={item.dataKey}
            name={item.name}
            stroke={item.color}
          />
        ))}
      </AreaChart>
    </ResponsiveContainer>
  )
}

export default ChartArea
